module.exports = __webpack_public_path__ + "img/approve.84ba8df7.svg";